module.exports = __webpack_public_path__ + "img/mob-ai-inter.b146a06f.svg";